<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <v-container grid-list-xl fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <h1 class="display-1">TomaxZone Management</h1>
            </v-flex>
            <v-flex xs6>
              <v-card>
                <v-container grid-list-xl fluid>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <h2 class="headline">{{AddEdit}} TomaxZone</h2>
                      <v-text-field type='Number' label="TomaxZone" v-model="tomaxZone"></v-text-field>
                      <v-text-field label="Ship Via" v-model="shipVia"></v-text-field>
                      <v-text-field type='Number' label="Other (Days)" v-model="otherDays"></v-text-field>
                      <v-text-field type='Number' label="Shutter (Days)" v-model="shutterDays"></v-text-field>
                      <v-btn v-if='tomaxZoneID' large color="primary" @click="updateTomaxZone">Edit TomaxZone</v-btn>
                      <v-btn v-else large color="primary" @click="addTomaxZone">Add TomaxZone</v-btn>
                      <v-btn v-if='tomaxZoneID' large color="primary" @click="clearFields">Cancel</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>

            <v-flex xs6>
              <v-card>
                <v-container grid-list-xl fluid>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-data-table :headers="headers" :items="tomaxzones">
                        <template slot="items" slot-scope="props">
                          <td @click="editTomaxZone(props.item._id)">{{ props.item.tomaxZone }}</td>
                          <td @click="editTomaxZone(props.item._id)">{{ props.item.shipVia }}</td>
                          <td @click="editTomaxZone(props.item._id)">
                              Other - {{ props.item.otherDays }}<br>
                              Shutter - {{ props.item.shutterDays }}
                          </td>
                          <td>
                            <!-- <button @click="editTomaxZone(props.item._id)">Edit</button> -->
                            <button @click="deleteTomaxZone(props.item._id)">Delete</button>
                          </td>
                        </template>
                    </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-snackbar dark top v-model="snackbar" :timeout="3000">
        {{ popupText }}
        <v-btn dark flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
import TomaxZoneService from '@/services/TomaxZoneService.js'
export default {
  data () {
    return {
      headers: [
        { text: 'TomaxZone', value: 'tomaxZone' },
        { text: 'Ship Via', value: 'shipVia' },
        { text: 'Label - Days', value: 'otherDays' },
        { text: 'Actions', value: 'actions' }
      ],
      tomaxzones: [],
      tomaxZone: null,
      shipVia: null,
      shutterDays: null,
      otherDays: null,
      tomaxZoneID: null,
      AddEdit: 'Add',
      popupText: '',
      snackbar: false
    }
  },
  mounted () {
    this.getTomaxZones()
  },
  methods: {
    async getTomaxZones () {
      const response = await TomaxZoneService.getTomaxZones()
      this.tomaxzones = response.data.tomaxzones
    },

    async addTomaxZone () {
      if (this.validation() === false) {
        return
      }
      await TomaxZoneService.addTomaxZone({
        tomaxZone: this.tomaxZone,
        shipVia: this.shipVia,
        otherDays: this.otherDays,
        shutterDays: this.shutterDays
      })
      this.popupText = `TomaxZone added.`
      this.snackbar = true
      this.clearFields()
      this.getTomaxZones()
    },

    async updateTomaxZone () {
      if (this.validation() === false) {
        return
      }
      await TomaxZoneService.updateTomaxZone({
        _id: this.tomaxZoneID,
        tomaxZone: this.tomaxZone,
        shipVia: this.shipVia,
        otherDays: this.otherDays,
        shutterDays: this.shutterDays
      })
      this.popupText = `TomaxZone ${this.tomaxZone} updated.`
      this.snackbar = true
      this.clearFields()
      this.getTomaxZones()
    },

    async deleteTomaxZone (id) {
      await TomaxZoneService.deleteTomaxZone(id)
      this.popupText = `TomaxZone deleted.`
      this.snackbar = true
      this.getTomaxZones()
    },
    async editTomaxZone (id) {
      var tomaxzone = await TomaxZoneService.getSingleTomaxZone(id)
      this.tomaxZoneID = tomaxzone.data.tomaxzone._id
      this.tomaxZone = tomaxzone.data.tomaxzone.tomaxZone
      this.shipVia = tomaxzone.data.tomaxzone.shipVia
      this.otherDays = tomaxzone.data.tomaxzone.otherDays
      this.shutterDays = tomaxzone.data.tomaxzone.shutterDays

      this.AddEdit = 'Edit'
    },
    clearFields () {
      this.tomaxZoneID = null
      this.tomaxZone = null
      this.shipVia = null
      this.otherDays = null
      this.shutterDays = null
      this.AddEdit = 'Add'
    },
    validation () {
      if (this.tomaxZone == null || this.shipVia == null || this.otherDays == null || this.shutterDays == null) {
        this.popupText = `All fileds are required.`
        this.snackbar = true
        return false
      }
      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/TomaxZones.vue